import type RootStore from "stores/RootStore";
import { RouteType } from "types/RouteType";
import DataMapperBrowseStore from "./DataMapperBrowseStore";

const browseStore = (rootStore: RootStore) =>
  rootStore.dataMapperBrowseViewStore as DataMapperBrowseStore;

/**
 * Data Mapper → Browse: the tables of the source this tab connected to on the
 * Data Source page, and a paged, filtered grid of one table's rows. Gated like
 * the Profiles route (see dataMapperProfiles.Route.ts).
 */
const dataMapperBrowseRoute: RouteType[] = [
  {
    name: "Data Mapper Browse",
    path: "/data-mapper/browse",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Browse Source",
        enableRefreshButton: true,
        component: () => import("./DataMapperBrowse.Header"),
      },
      body: {
        component: () => import("./DataMapperBrowse.Body"),
        grayBackground: true,
      },
    },
    group: "Data Mapper",
    searchAliases: ["data mapper browse", "source tables", "source data", "browse source"],
    requiresAuth: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      void browseStore(rootStore)?.enter();
    },
    onExit: ({ rootStore }) => {
      browseStore(rootStore)?.reset();
    },
  },
];

export default dataMapperBrowseRoute;
